import { FadeUp, MaskLines } from "./Reveal";

const CARDS = [
  {
    n: "01",
    t: "AI assistants for teams",
    d: "Rollout of Claude, ChatGPT Enterprise or Microsoft Copilot with playbooks and access controls.",
  },
  {
    n: "02",
    t: "AI on your company data",
    d: "Connect CRM, email and drive so answers use real business context.",
  },
  {
    n: "03",
    t: "Document automation",
    d: "Quotations, contracts and invoices drafted by AI, approved by people.",
  },
  {
    n: "04",
    t: "Voice and WhatsApp agents",
    d: "Reservations, reminders and support.",
  },
  {
    n: "05",
    t: "Knowledge assistant",
    d: "Trained on your SOPs for faster onboarding.",
  },
  {
    n: "06",
    t: "Management copilots",
    d: "Meeting notes, CRM updates and follow-up drafts.",
  },
];

export default function ImplementationPartner() {
  return (
    <section className="scroll-mt-20 bg-ink py-24 md:py-28">
      <div className="mx-auto max-w-[1160px] px-6">
        <FadeUp>
          <p
            className="text-[13px] font-semibold uppercase tracking-[0.18em] text-brand-soft"
            data-testid="implementation-eyebrow"
          >
            04 — Implementation Partner
          </p>
        </FadeUp>

        <MaskLines
          lines={["We bring AI into your", "organisation — properly."]}
          className="mt-8 text-[clamp(2.5rem,5.4vw,4.6rem)] font-normal leading-[1.04] tracking-[-0.025em] text-white"
        />

        <FadeUp delay={0.1}>
          <p className="mt-8 max-w-[600px] text-[17px] leading-[1.65] text-[#9a9aa3]">
            Buying AI tools is easy. Getting a team to use them well is the hard part. We
            assess, set up, integrate and train.
          </p>
        </FadeUp>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((c, i) => (
            <FadeUp key={c.n} delay={i * 0.06} className="h-full">
              <div
                className="h-full rounded-xl border border-white/[0.07] bg-white/[0.02] p-8 transition-colors duration-300 hover:border-white/[0.18]"
                data-testid={`impl-card-${c.n}`}
              >
                <p className="text-[14px] font-medium text-brand">{c.n}</p>
                <h3 className="mt-8 text-[26px] font-medium leading-[1.2] tracking-[-0.01em] text-white">
                  {c.t}
                </h3>
                <p className="mt-3 text-[16px] leading-[1.6] text-[#9a9aa3]">{c.d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
